@if (loading) {
<div class="wrapper">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate"
    diameter="50"
    strokeWidth="4"
  ></mat-progress-spinner>
</div>
}
